"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudSharedProductionEnvironment = void 0;
exports.CloudSharedProductionEnvironment = {
    apiUrl: "https://api.smallstack.com",
    applicationsProxyUrl: "proxy.smallstack.app",
    applicationsProxyIp: "35.198.76.42",
    applicationsPreviewUrlSuffix: "preview.smallstack.app",
    applicationsConnectUrl: "https://connect.smallstack.app",
    checkinUrl: "https://checkin.smallstack.com",
    backofficeUrl: "https://cloud.smallstack.com"
};
